import { Directive } from "@angular/core";

import { NzDrawerContentDirective } from "ng-zorro-antd/drawer";

@Directive({
  selector: "[uiDrawerContent]",
  exportAs: "uiDrawerContent",
})
export class DrawerContentDirective extends NzDrawerContentDirective {}
